<div class="container-fluid tabs_mobile home not_mobile_only">
  <div class="home_tabs">
    <ng-container *ngFor="let tab of tabs">
      <div class="home_tab pointer" *ngIf="tab.enabled === true && filter" [style.border-color]="getBorderColor(tab)"
        [class.active]="filter === tab.name" (click)="goTo(tab)">
        <span class="home_tab_name">
          {{ tab.value | customTranslation:'MENU_TABS.' + tab.value.toUpperCase():translateService.currentLang | translate }}
        </span>
        <span class="bold home_tab_value mobile_only" *ngIf="!tab.displayCount"><br></span>
      </div>
    </ng-container>
  </div>
</div>

<app-filters [filter]="filter" *ngIf="filter !== 'ONLY_MAPS'"></app-filters>


